import { defineComponent } from 'vue';
import { QInput, QIcon, QTooltip } from 'quasar';
import utils from '../../../../Shared/utils.jsx';
import methods from '../../../../Shared/methods';

export default defineComponent({
    name: 'form-input-multiline-dsgn',
    components: {
        QInput,
        QIcon,
        QTooltip,
    },
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        ...utils.forms.computed,
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedNode == this;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        designmodel: null,
        schema: null,
        form: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
    },
    render() {
        const placeholder = (this.form ?? this.schema)?.placeholder || '';
        const titletext = this.form?.title || this.schema.title;
        const description = this.form?.description || this.schema.description;
        const rows = (this.form?.schema ?? this.schema)?.formatData?.Rows || '4';
        const value = this.cmodel?.[this.schemakey] ?? '';

        return (
            <div
                class={{ 'designer-form': true }}
                style={{ xmarginLeft: (this.child * 15) + 'px', position: 'relative' }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <QInput
                    type="textarea"
                    rows={rows}
                    class="caption q-pa-none q-ma-none"
                    outlined
                    dense
                    label={titletext}
                    hide-bottom-space
                    hint={description}
                    modelValue={value}
                    placeholder={placeholder}
                    style={{ width: '100%' }}
                >
                </QInput>
            </div>
        );
    }
});
